function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRankRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.286 21l-.897-9.836 3.45 2.463 1.68 1.201 1.145-1.719L16 6.605l4.336 6.504 1.145 1.719 1.681-1.201 3.45-2.463L25.713 21H6.286zM22 12l-6-9-6 9-7-5 1.46 16H27.541L29 7l-7 5zM25.166 27l-18.333-.009L6.651 25H4.643l.198 2.174A2 2 0 006.834 29h18.332a2 2 0 001.993-1.826L27.357 25H25.35l-.183 2z",
    fill: props.color
  }));
}

export default SvgIconRankRexOutline;